import general from './general';
import {fixHeightMobile, locomotivePageInit} from './functions';

const blogPage = {
    init: function() {
        document.addEventListener('DOMContentLoaded', () => {
            this.awardsPageDesktop();
            this.awardsPageMobile();
            locomotivePageInit();
            fixHeightMobile();
        });
    },

    awardsPageDesktop: function() {
        if ($('.awards-page__slider-inner').length === 0 || $(window).width() < 768) return;

        let awardsSlider = null,
            years = [],
            lastYear = null,
            innerWidth = 0,
            widthItem = 0,
            coordsArray = [],
            scrollTimer = null;

        let fillYearsList = () => {
            years = [];
            $('.awards-page__years-list').html('');

            let checkedInput = $('.awards-page__toggle-body').find('input:checked');
            let value = checkedInput.val();

            $('[data-city=' + value + '] .awards-page__item').each(function () {
                years.push($(this).data('year'));
            });

            years = Array.from(new Set(years));

            lastYear = Math.max(...years);

            for (let index = 0; index < years.length; index++) {
                const year = years[index];
                $('.awards-page__years-list').append(
                    `<button type="button" class="awards-page__year" data-year="${year}">${year}</button>`
                );
            }

            $('.awards-page__year').on('click', function () {
                if (awardsSlider.hasClass('no-snap')) return;
                let targetItem = $(`.awards-page__item[data-year="${$(this).data('year')}"]`).first();
                if (targetItem) {
                    scrollAwardsSlider(targetItem.position().left + awardsSlider.scrollLeft() - widthItem, 400);
                }
            });
        }

        const awards_page__item = $('.awards-page__item');
        let initParamsSlider = (startScreen) => {
            widthItem = awards_page__item.outerWidth();
            awardsSlider = $('.awards-page__slider-inner');
            coordsArray = [];
            innerWidth = 0;

            fillYearsList();

            awards_page__item.each(function (index, el) {
                innerWidth = innerWidth + $(el).outerWidth();
            });

            awards_page__item.each(function (index, el) {
                coordsArray.push($(this).offset().left + awardsSlider.scrollLeft());
            });

            innerWidth = innerWidth - widthItem * 3;

            awardsSlider.on('scroll', function() {
                let progress = $(this).scrollLeft();
                let offset = 100;
                let currentItem = undefined;

                coordsArray.find(function (coord, index) {
                    if (coord >= progress - offset && coord <= progress + offset) {
                        currentItem = index + 1;
                    } else if (progress === 0) {
                        currentItem = 0;
                    }
                });

                clearTimeout(scrollTimer);

                scrollTimer = setTimeout(function() {
                    if (typeof currentItem !== 'undefined') {
                        let item = $(`.awards-page__item:eq(${currentItem})`);
                        $('.awards-page__year').removeClass('active');
                        $(`.awards-page__year[data-year="${item.data('year')}"]`).addClass('active');
                        $('.awards-page__desc span').html(item.data('desc'));
                    }
                }, 100);
            });

            let startItem = $('.awards-page__item').eq(2);
            if (startItem.length === 0) {
                startItem = $(`.awards-page__item[data-year="${lastYear}"]`).first();
            }
            $(`.awards-page__year[data-year="${startItem.data('year')}"]`).addClass('active');
            $('.awards-page__desc span').html(startItem.data('desc'));

            if (startScreen) {
                window.addEventListener('load', function() {
                    scrollAwardsSlider(startItem.position().left + awardsSlider.scrollLeft() - widthItem, 0);
                    startItem.next().data('start-size', '0.65:-17:10').css('transform', 'scale(0.65) translateX(-17vw)');
                    startItem.prev().data('start-size', '0.65:17:-10').css('transform', 'scale(0.65) translateX(17vw)');
                    startItem.next().next().data('start-size', '0.5:-50:40').css('transform', 'scale(0.5) translateX(-50vw)');
                    startItem.prev().prev().data('start-size', '0.5:50:-40').css('transform', 'scale(0.5) translateX(50vw)');
                    setTimeout(() => $('.awards-page__slider').addClass('show'), 300);
                });
            } else {
                scrollAwardsSlider(startItem.position().left + awardsSlider.scrollLeft() - widthItem, 0);
            }
        }

        $(document).on('update-awards-slider', () => initParamsSlider());
        initParamsSlider(true);
        $(window).on('resize', () => initParamsSlider());

        $('.awards-page__slider-btn').on('click', function() {
            if (awardsSlider.hasClass('no-snap')) return;
            switch (true) {
                case $(this).hasClass('awards-page__slider-btn_left'):
                    scrollAwardsSlider(awardsSlider.scrollLeft() - awards_page__item.innerWidth(), 400);
                    break;

                case $(this).hasClass('awards-page__slider-btn_right'):
                    scrollAwardsSlider(awardsSlider.scrollLeft() + awards_page__item.innerWidth(), 400);
                    break;
            }
        });

        function scrollAwardsSlider(offset, time) {
            awardsSlider.addClass('no-snap');
            awardsSlider.animate({
                scrollLeft: offset
            }, time, function() {
                awardsSlider.removeClass('no-snap');
            });
        }

        $('.awards-page__toggle').on('click', function () {
            $(this).toggleClass('show');
        });

        $(document).on('click', function (event) {
            if (event.target.closest('.awards-page__toggle')) return;
            $('.awards-page__toggle').removeClass('show');
        });

        let changeCityAwards = (fillYearsList) => {
            const awards_page__toggle_body = $('.awards-page__toggle-body');
            let checkedInput = awards_page__toggle_body.find('input:checked');
            let value = checkedInput.val();
            $('.awards-page__toggle-head span').text(awards_page__toggle_body.find(`label[for="${checkedInput.attr('id')}"]`).text());
            $('.awards-page__toggle').removeClass('show');
            $('.awards-page__slider').addClass('display-none');
            $(`.awards-page__slider[data-city=${value}]`).removeClass('display-none');
            fillYearsList();
        }

        changeCityAwards(fillYearsList);

        $('[name="awards-city-toggle"]').on('change', function() {
            changeCityAwards(fillYearsList);
        });
    },

    awardsPageMobile: function() {
        if ($(window).width() > 767 || $('.awards-page_mobile').length === 0) return;

        let swithYear = (year, withhoutAnim) => {
            $('.awards-page__slider-inner').flickity(
                'select',
                $(`.awards-page__item[data-year="${year}"]`).first().index(),
                false,
                withhoutAnim
            );
        }

        let initAwardsFlickity = () => {
            let items = document.querySelectorAll('.awards-page__item');
            let years = [...new Set(Array.from(items).map((item) => item.getAttribute('data-year')))];
            let lastYear = Math.max(...years);

            $('.flickity-enabled').each(function() {
                $(this).flickity('destroy');
            });

            const awards_page__slider_inner = $('.awards-page__slider-inner');
            awards_page__slider_inner.flickity({
                cellAlign: "left",
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                on: {
                    select: function() {
                        const awards_page__item = $(`.awards-page__item:eq(${this.selectedIndex})`);
                        let year = awards_page__item.data('year');
                        let desc = awards_page__item.data('desc');
                        $('.awards-page__desc span').html(desc);
                        $('#controll-year').text(year);
                        $(document).trigger("switch-year", [year]);
                    },
                },
            });

            $('.awards-page__slider-dots').flickity({
                asNavFor: '.awards-page__slider-inner',
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                on: {
                    select: function() {
                        $('.awards-page__slider-dot').removeClass('neighbours siblings');
                        $(`.awards-page__slider-dot:eq(${this.selectedIndex - 1})`).addClass('siblings');
                        $(`.awards-page__slider-dot:eq(${this.selectedIndex + 1})`).addClass('siblings');
                        $(`.awards-page__slider-dot:eq(${this.selectedIndex - 2})`).addClass('neighbours');
                        $(`.awards-page__slider-dot:eq(${this.selectedIndex + 2})`).addClass('neighbours');
                    },
                },
            });

            awards_page__slider_inner.addClass('show');

            swithYear(lastYear, true);
        }

        initAwardsFlickity();

        $(document).on('awards-click-year', function(event, year) {
            swithYear(year);
        });

        $('.awards-page__controll').on('click', function() {
            $('popup_switch-awards').addClass('show');
        });

        function downloadAwards(value, name) {
            let container = $('.awards-page__slider');
            let url = container.data('url');

            $.ajax({
                url: url + '?city=' + value,
                beforeSend: () => {
                    $('.awards-page__section').addClass('waiting');
                },
                success: (res) => {
                    $('.awards-page__container').addClass('init');
                    $('.awards-page__section').removeClass('waiting');
                    container.html(res);
                    initAwardsFlickity();
                    $(document).trigger('switch-city', [value]);
                    $('#controll-city').text(name);
                    $(document).trigger('refresh-buttons');
                },
            });
        }

        $(document).on('awards-click-city', (e, value, name) => downloadAwards(value, name));
    },
};

general.init();
blogPage.init();
